import { countryConverter, Country } from '../models/Country'
import { firebaseDb } from './firebase'
import { Collection } from '../config/enums'

/**
 * Retrieves the list of countries (Country object) from Firebase Firestore
 */
export const getCountries = async (): Promise<Country[]> => {
  let countries: Country[] = []

  try {
    const snapshot = await firebaseDb
      .collection(Collection.countries)
      .orderBy('name')
      .withConverter(countryConverter)
      .get()

    snapshot.forEach(doc => {
      countries.push(doc.data())
    })
  } catch (err) {
    console.error(err)
  }

  return countries
}

export const getFilteredCountries = async (
  countryNames: string[]
): Promise<Country[]> => {
  let countries: Country[] = []

  try {
    const snapshot = await firebaseDb
      .collection(Collection.countries)
      .where('name', 'in', countryNames)
      .withConverter(countryConverter)
      .get()

    snapshot.forEach(doc => {
      countries.push(doc.data())
    })

    countries.sort((a, b) => {
      return a.name < b.name ? -1 : a.name === b.name ? 0 : 1
    })
  } catch (err) {
    console.error(err)
  }

  return countries
}

/**
 * Retrieves a country document by id
 */
export const getCountry = async (id: string): Promise<Country | undefined> => {
  try {
    const snapshot = await firebaseDb
      .collection(Collection.countries)
      .withConverter(countryConverter)
      .doc(id)
      .get()

    return snapshot.data()
  } catch (err) {
    console.error(err)
  }

  return undefined
}

/**
 * Retrieves a country document by name
 */
export const getCountryByName = async (
  name: string
): Promise<Country | undefined> => {
  try {
    const snapshot = await firebaseDb
      .collection(Collection.countries)
      .withConverter(countryConverter)
      .where('name', '==', name)
      .limit(1)
      .get()

    return snapshot.empty ? undefined : snapshot.docs[0].data()
  } catch (err) {
    console.error(err)
  }

  return undefined
}
